import { Injectable } from '@angular/core'
import {
  CanActivate, ActivatedRouteSnapshot,
  RouterStateSnapshot, CanActivateChild } from '@angular/router'
import { Observable } from 'rxjs'

import { QueryString } from 'app/models'

import { AuthService } from './auth.service'

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {
  constructor(public authService: AuthService) { }

  public canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> {
    const returnURL = this.makeURL(route)

    return new Observable<boolean>((observer) => {
      this.authService.isAuthenticated().then((authenticated) => {
        observer.next(authenticated)
        observer.complete()
        if (!authenticated) {
          this.authService.initiateLogin(returnURL)
        }
      })
    })
  }

  public canActivateChild(route: ActivatedRouteSnapshot,
                          state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state)
  }

  public makeURL(route: ActivatedRouteSnapshot): string {
    const qs = QueryString.build(route.queryParamMap)
    const path = '/' + this.getDescendentPath(route)
    return qs.length === 0 ? path : path + '?' + qs
  }

  private getDescendentPath(route: ActivatedRouteSnapshot): string {
    if (!route.children?.length) return route.url.map(seg => seg.path).join('/')
    return route.url.map(seg => seg.path).join('/') + '/' +
      route.children.map(child => this.getDescendentPath(child)).join('/')
  }
}
